import { ColumnsType } from 'antd/es/table/interface';
import { TFunction } from 'i18next';
import { EditFilled, DeleteFilled, PlusOutlined } from '@ant-design/icons';
import {
	handleCountrySortClick,
	handleCreatedAtSortClick,
	handleFullNameSortClick,
	handlePhoneNumberSortClick,
} from './handleClientsTableSortClick';
import { Link } from 'react-router-dom';
import { AccountGroup } from '../models/AccountGroup';
import { Modal } from 'antd';
import axios from 'axios';
import { API_ENDPOINTS } from '../assets/api/endpoints';

import { ColumnTitle } from '../components/ColumnTitle/ColumnTitle';
export const getAccountGroupColumns = (
	t: TFunction<'translation', undefined, 'translation'>,
	sortBy: string,
	setSortBy: (sortValue: string) => void,
	reloadData: () => void,
) => {
	const showDeleteConfirmation = (tradingPlatform: any, tradingGroup: any) => {
		Modal.confirm({
			title: t('confirmDelete'),
			content: t('deleteConfirmation'),
			okText: t('ok'),
			cancelText: t('cancel'),
			onOk() {
				axios
					.delete(`${API_ENDPOINTS.accountGroupsLimits}`, {
						data: {
							group: tradingGroup,
							tradingPlatform: tradingPlatform,
						},
					})
					.then((res) => {
						reloadData();
					})
					.catch((err) => console.error(err));
			},
			onCancel() {
				Modal.destroyAll();
			},
		});
	};
	const columns: ColumnsType<AccountGroup> = [
		{
			title: (
				<Link to={'/add-account-group'}>
					<PlusOutlined className='flex items-center cursor-pointer text-black font-bold' alt='add' />
				</Link>
			),
			dataIndex: 'id',
			key: 'action',
			ellipsis: true,
			responsive: ['lg'],
			render: (value, record) => {
				return (
					<div className='flex'>
						{record.tradingPlatform && record.tradingAccountGroup ? (
							<div className='flex items-center'>
								{' '}
								<Link
									to={`/account-groups/${record.tradingPlatform}?tradingAccountGroups=${
										record.tradingAccountGroup
									}&buyMin=${record.buyMin ?? ''}&buyMax=${record.buyMax ?? ''}&sellMin=${
										record.sellMin ?? ''
									}&sellMax=${record.sellMax ?? ''}&depositBonus=${record.depositBonus ?? ''}&withdrawCommission=${
										record.withdrawCommission ?? ''
									}&depositRatio=${record.depositRatio ? '1' : '0'}&withdrawRatio=${
										record.withdrawRatio ? '1' : '0'
									}&groupName=${record.groupName ?? ''}`}
								>
									<EditFilled className='flex items-center cursor-pointer   text-black font-bold' />
								</Link>
								<DeleteFilled
									onClick={() => showDeleteConfirmation(record.tradingPlatform, record.tradingAccountGroup)}
									className='hover:text-[#F6465D] text-[#000D1D99] px-2   cursor-pointer'
								/>
							</div>
						) : (
							<>
								{!record.tradingPlatform && !record.tradingAccountGroup ? (
									<div className='flex items-center justify-center w-[100%]'>
										{' '}
										<DeleteFilled
											onClick={() => showDeleteConfirmation(record.tradingPlatform, record.tradingAccountGroup)}
											className='hover:text-[#F6465D] text-[#000D1D99] px-2  cursor-pointer'
										/>
									</div>
								) : (
									<>
										<Link
											to={`/account-groups/${record.tradingPlatform}?tradingAccountGroups=${
												record.tradingAccountGroup
											}&buyMin=${record.buyMin ?? ''}&buyMax=${record.buyMax ?? ''}&sellMin=${
												record.sellMin ?? ''
											}&sellMax=${record.sellMax ?? ''}&depositBonus=${record.depositBonus ?? ''}&withdrawCommission=${
												record.withdrawCommission ?? ''
											}&depositRatio=${record.depositRatio ? '1' : '0'}&withdrawRatio=${
												record.withdrawRatio ? '1' : '0'
											}&groupName=${record.groupName ?? ''}`}
										>
											<EditFilled className='flex items-center cursor-pointer  text-black font-bold' />
										</Link>
										<DeleteFilled
											onClick={() => showDeleteConfirmation(record.tradingPlatform, record.tradingAccountGroup)}
											className='hover:text-[#F6465D] text-[#000D1D99]  px-2   cursor-pointer'
										/>
									</>
								)}
							</>
						)}
					</div>
				);
			},
		},
		{
			title: <ColumnTitle title={t<string>('tradingPlatform')} />,
			onHeaderCell: () => {
				return {
					onClick: () => {
						setSortBy(handleFullNameSortClick(sortBy));
					},
				};
			},
			dataIndex: 'tradingPlatform',
			key: 'tradingPlatform',
			ellipsis: true,
			responsive: ['lg'],
			render: (value, record) => {
				return <div className='text-lightBlue font-bold '>{value ? value : t('public')}</div>;
			},
		},
		{
			title: <ColumnTitle title={t<string>('tradingAccountGroup')} />,
			onHeaderCell: () => {
				return {
					onClick: () => {
						setSortBy(handlePhoneNumberSortClick(sortBy));
					},
				};
			},
			dataIndex: 'tradingAccountGroup',
			key: 'tradingAccountGroup',
			responsive: ['lg'],
			render: (value) => {
				return <div className='font-bold text-[#999999] Blue flex items-center'>{value ? value : t('public')}</div>;
			},
		},
		{
			title: <ColumnTitle title={t<string>('buyMin')} />,
			onHeaderCell: () => {
				return {
					onClick: () => {
						setSortBy(handleCountrySortClick(sortBy));
					},
				};
			},
			dataIndex: 'buyMin',
			key: 'buyMin',
			responsive: ['lg'],
			render: (row, record) => (
				<div className=' font-medium text-lightBlue flex items-center'>{record.buyMin?.toLocaleString()}</div>
			),
			ellipsis: true,
		},
		{
			title: <ColumnTitle title={t<string>('buyMax')} />,
			onHeaderCell: () => {
				return {
					onClick: () => {
						setSortBy(handleCountrySortClick(sortBy));
					},
				};
			},
			dataIndex: 'buyMax',
			key: 'buyMax',
			responsive: ['lg'],
			render: (row, record) => (
				<div className=' font-medium text-lightBlue flex items-center'>{record.buyMax?.toLocaleString()}</div>
			),
			ellipsis: true,
		},
		{
			title: <ColumnTitle title={t<string>('sellMin')} />,
			onHeaderCell: () => {
				return {
					onClick: () => {
						setSortBy(handleCountrySortClick(sortBy));
					},
				};
			},
			dataIndex: 'sellMin',
			key: 'sellMin',
			responsive: ['lg'],
			render: (row, record) => (
				<div className=' font-medium text-lightBlue flex items-center'>{record.sellMin?.toLocaleString()}</div>
			),
			ellipsis: true,
		},
		{
			title: <ColumnTitle title={t<string>('sellMax')} />,
			onHeaderCell: () => {
				return {
					onClick: () => {
						setSortBy(handleCreatedAtSortClick(sortBy));
					},
				};
			},
			dataIndex: 'sellMax',
			key: 'sellMax',
			responsive: ['lg'],
			render: (row, record) => (
				<div className='  font-medium text-lightBlue flex items-center'>{record.sellMax?.toLocaleString()}</div>
			),
		},
		{
			title: (
				<div className='flex justify-center'>
					<Link to={'/add-account-group'}>
						<PlusOutlined className='flex items-center cursor-pointer text-[20px] text-black font-bold' />
					</Link>
				</div>
			),
			dataIndex: 'record',
			className: 'small-screen-row-header',
			render: (value, row) => {
				return (
					<div className='flex py-2 pb-0 justify-between'>
						<div className='flex-col w-full'>
							<div className='text-sm  h-6  flex justify-between'>
								<span className='text-[#01081E99] block'>{t<string>('tradingPlatform')}</span>

								<div className='flex mt-0 mb-0'>
									{row.tradingPlatform && row.tradingAccountGroup ? (
										<div className='flex items-center'>
											{' '}
											<Link
												to={`/account-groups/${row.tradingPlatform}?tradingAccountGroups=${
													row.tradingAccountGroup
												}&buyMin=${row.buyMin ?? ''}&buyMax=${row.buyMax ?? ''}&sellMin=${row.sellMin ?? ''}&sellMax=${
													row.sellMax ?? ''
												}&depositBonus=${row.depositBonus ?? ''}&withdrawCommission=${
													row.withdrawCommission ?? ''
												}&depositRatio=${row.depositRatio ? '1' : '0'}&withdrawRatio=${
													row.withdrawRatio ? '1' : '0'
												}&groupName=${row.groupName ?? ''}`}
											>
												<EditFilled className='p-3 flex items-center cursor-pointer text-[20px] text-black font-bold' />
											</Link>
											<DeleteFilled
												onClick={() => showDeleteConfirmation(row.tradingPlatform, row.tradingAccountGroup)}
												className='hover:text-[#F6465D] text-[#000D1D99]  text-xl h-4 w-4 cursor-pointer'
											/>
										</div>
									) : (
										<>
											{!row.tradingPlatform && !row.tradingAccountGroup ? (
												<div className='flex items-center justify-center w-[100%]'>
													{' '}
													<DeleteFilled
														onClick={() => showDeleteConfirmation(row.tradingPlatform, row.tradingAccountGroup)}
														className='hover:text-[#F6465D] text-[#000D1D99]  text-xl h-4 w-4 cursor-pointer'
													/>
												</div>
											) : (
												<>
													<Link
														to={`/account-groups/${row.tradingPlatform}?tradingAccountGroups=${
															row.tradingAccountGroup
														}&buyMin=${row.buyMin ?? ''}&buyMax=${row.buyMax ?? ''}&sellMin=${
															row.sellMin ?? ''
														}&sellMax=${row.sellMax ?? ''}&depositBonus=${row.depositBonus ?? ''}&withdrawCommission=${
															row.withdrawCommission ?? ''
														}&depositRatio=${row.depositRatio ? '1' : '0'}&withdrawRatio=${
															row.withdrawRatio ? '1' : '0'
														}&groupName=${row.groupName ?? ''}`}
													>
														<EditFilled className='p-3 flex items-center cursor-pointer text-[20px] text-black font-bold' />
													</Link>
													<DeleteFilled
														onClick={() => showDeleteConfirmation(row.tradingPlatform, row.tradingAccountGroup)}
														className='hover:text-[#F6465D] text-[#000D1D99]  text-xl h-4 w-4 cursor-pointer'
													/>
												</>
											)}
										</>
									)}
									<span className=' text-lightBlue mx-2 block'>
										{row.tradingPlatform ? row.tradingPlatform : t('public')}
									</span>
								</div>
							</div>
							<div className=' items-center h-6 mt-1 flex justify-between'>
								<span className=' text-[#01081E99] block'>{t<string>('tradingAccountGroup')}</span>
								<span className=' text-lightBlue mx-2 block'>
									{row.tradingAccountGroup ? row.tradingAccountGroup : t('public')}
								</span>
							</div>
							<div className=' items-center h-6 mt-1 flex justify-between'>
								<span className=' text-[#01081E99] block'>{t<string>('buyMin')}</span>
								<span className=' text-lightBlue mx-2 block'>{row.buyMin}</span>
							</div>
							<div className=' items-center h-6 mt-1 flex justify-between'>
								<span className='text-[#01081E99] block'>{t<string>('buyMax')}</span>
								<span className=' text-lightBlue mx-2 block'>{row.buyMax}</span>
							</div>
							<div className='flex items-center h-6 mt-1  justify-between'>
								<span className=' text-[#01081E99] block'>{t<string>('sellMin')}</span>
								<span className=' text-lightBlue mx-2 block'>{row.sellMin?.toLocaleString()}</span>
							</div>
							<div className='flex items-center h-6 mt-1  justify-between'>
								<span className=' text-[#01081E99] block'>{t<string>('sellMax')}</span>
								<span className=' text-lightBlue mx-2 block'>{row.sellMax?.toLocaleString()}</span>
							</div>
						</div>
					</div>
				);
			},
		},
	];

	return columns;
};
